var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCd = function SvgCd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.414,20.635c-0.225,0-0.428-0.145-0.492-0.371c-0.078-0.271,0.08-0.555,0.352-0.631         c3.348-0.955,5.686-4.055,5.686-7.54s-2.338-6.585-5.686-7.539c-0.271-0.077-0.43-0.36-0.352-0.632         c0.076-0.272,0.359-0.43,0.633-0.352c3.783,1.078,6.428,4.583,6.428,8.522c0,3.939-2.645,7.444-6.428,8.524         C17.508,20.629,17.459,20.635,17.414,20.635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.902,20.953H1.041c-0.565,0-1.023-0.459-1.023-1.021V4.07c0-0.565,0.458-1.023,1.023-1.023h15.862         c0.562,0,1.021,0.458,1.021,1.023v4.015c0,0.501-0.352,0.924-0.84,1.005c-1.949,0.323-2.16,2.005-2.16,2.713s0.211,2.39,2.16,2.713         c0.488,0.08,0.84,0.504,0.84,1.004v4.412C17.924,20.494,17.465,20.953,16.902,20.953 M1.041,4.07v15.862h15.862V15.52         c-1.844-0.303-3.002-1.729-3.002-3.717c0-1.988,1.158-3.415,3.018-3.722L16.902,4.07H1.041z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cd.d6e4e5b1.svg";
export { ForwardRef as ReactComponent };